<template>
  <div class="coop-banner" ref="banner">
    <div class="container">
      <div class="banner_i">
        <h4 class="wow fadeInUp" data-wow-delay="50ms">{{ info.name }}</h4>
        <!-- <h6 class="wow fadeInUp" data-wow-delay="150ms" v-html="info.context">{{ info.title }}</h6> -->
        <h6 class="wow fadeInUp" data-wow-delay="150ms">{{ info.title }}</h6>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <div class="video_model" v-if="videoSrc" v-show="showVideo">
      <div class="mask" @click="stopVideo"></div>
      <div class="inner">
        <i class="el-icon-close" @click="stopVideo"></i>
        <video ref="video" :src="videoSrc" controls x5-playsinline playsinline webkit-playsinline></video>
      </div>
    </div>
  </div>
</template>

<script>
if (process.browser) {
  // 在这里根据环境引入wow.js
  var { WOW } = require('wowjs')
}
export default {
  name: 'banner',
  props: ['info'],
  mounted() {
    if (process.browser) {
      // 在页面mounted生命周期里面 根据环境实例化WOW
      let newsList = 0
      new WOW({
        live: false,
        callback: function(e) {
          if (e.getAttribute('data-type') == 'newsList') {
            newsList += 50
            e.style.animationDelay = newsList + 'ms'
          }
        }
      }).init()
    }
  },
  data() {
    return {
      showVideo: false,
      videoSrc: null
    }
  },
  methods: {
    startVideo(src) {
      if (!src) return
      this.videoSrc = src
      this.showVideo = true
      setTimeout(() => {
        this.$refs.video && this.$refs.video.play()
      })
      document.querySelector('html').classList.add('oh')
    },
    stopVideo() {
      this.showVideo = false
      this.$refs.video.pause()
      document.querySelector('html').classList.remove('oh')
    }
  }
}
</script>

<style lang="less" scoped>
.coop-banner {
  background: #f6f6f9;
  height: 400px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .banner_i {
    padding: 120px 0 100px;
    text-align: center;
    h4 {
      font-size: 40px;
      font-weight: bold;
      color: #000;
      line-height: 56px;
    }

    h6 {
      font-size: 20px;
      color: #202640;
      line-height: 30px;
      font-weight: normal;
      margin-top: 20px;
    }

    .btn_g {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 50px;

      a {
        width: 120px;
        display: block;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        transition: all 0.3s;
      }
      a.sy {
        background: #e61717;
        color: #fff;
      }

      a.gk {
        border: 1px solid #000;
      }

      a.sy:hover {
        -webkit-transform: translateY(-4px);
        -ms-transform: translateY(-4px);
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(50, 10, 10, 0.2);
      }

      a.gk:hover {
        -webkit-transform: translateY(-4px);
        -ms-transform: translateY(-4px);
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
    }
  }
}

@media (max-width: 1024px) {
  .coop-banner {
    // height: 480px;
    .banner_i {
      h4 {
        font-size: 32px;
        line-height: 42px;
      }

      h6 {
        // width: 520px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}

@media (max-width: 768px) {
  .coop-banner {
    height: auto;
    .banner_i {
      background: unset !important;
      padding: 22vw 0 22vw;
      h4 {
        font-size: 24px;
        line-height: 32px;
      }

      h6 {
        width: 100%;
        font-size: 15px;
      }
    }
  }
}
</style>
